import React from 'react';
import { doc, collection, query, where, orderBy, limit, onSnapshot, getDocs } from 'firebase/firestore';

import MsgNetLoading from '../components/MsgNetLoading';
import ControlSelector from '../components/ControlSelector';
import ResultadoList from '../components/ResultadoList';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import GeneroSelector from '../components/GeneroSelector';
import SharePanel from '../components/SharePanel';
import TopHeaderMenu from '../components/TopHeaderMenu';
import { FirebaseContext } from '../index';
import { useNavigate, useParams } from 'react-router-dom';

const RESULTADOS_MOSTRAR = 10;

class CompeticionScreenClass extends React.Component {
  constructor(props) {
    super(props);

    let resultados = [];
    let i = 0;
    while (i < 10) {
      resultados.push({
        puesto: 0,
        nombre: '...',
        apellidos: '',
        dorsal: i,
        tiempo: 0,
        preload: true
      });
      i++;
    }
    this.state = {
      evento: null,
      competicion: null,
      sectores: [],
      controles: [],
      controlId: null,
      resultados: [resultados],
      generoSelectedIndex: 1,
      showSharePanel: false
    };
    this.unlisten = {};
    this.controlesVistos = [];
  }

  toogleSharePanel() {
    this.setState(state => ({
      showSharePanel: !this.state.showSharePanel
    }));
  }

  componentDidMount() {
    const { db, params } = this.props;
    const competicionId = parseInt(params.competicionId, 10);

    if (competicionId) {
      const competicionRef = doc(db, 'competicion', String(competicionId));
      this.unlisten.competicion = onSnapshot(competicionRef, (snapshot) => {
        let competicion = snapshot.exists() ? snapshot.data() : null;
        if (competicion) {
          competicion.id = snapshot.id;
        }
        this.setState({ competicion });
      });
    }

    // Controles
    const controlesQuery = query(
      collection(db, 'control'),
      where('competicion_id', '==', competicionId),
      where('visible', '==', true),
      orderBy('distancia', 'asc')
    );
    this.unlisten.controles = onSnapshot(controlesQuery, (snapshot) => {
      let controles = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      this.setState({ controles });
    });

    // Sectores
    const sectoresQuery = query(
      collection(db, 'sector'),
      where('competicion_id', '==', competicionId),
      orderBy('inicio', 'asc')
    );
    this.unlisten.sectores = onSnapshot(sectoresQuery, (snapshot) => {
      let sectores = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      this.setState({ sectores });
    });
  }

  onClickBack() {
    this.props.navigate(`/${this.state.competicion.evento_id}`);
  }

  _seleccionaResultadosAdecuados(nextState) {
    // const state = nextState || this.state;
    const state = this.state;

    const { db } = this.props;

    if (this.unlisten.resultados) {
      this.unlisten.resultados();
    }

    let generoSelectedIndex = state.generoSelectedIndex;
    if (state.competicion.mostrar_filtro_sexo) {
      // Mantener selección actual
    } else {
      generoSelectedIndex = 1;
    }

    let resultadosQuery;
    if (generoSelectedIndex === 1) {
      resultadosQuery = query(
        collection(db, 'resultado'),
        where('control_' + state.controlId + '_puesto', '>', 0),
        orderBy('control_' + state.controlId + '_puesto', 'asc'),
        limit(state.competicion.resultados_control_mostrar || RESULTADOS_MOSTRAR)
      );
    } else if (generoSelectedIndex === 2) {
      resultadosQuery = query(
        collection(db, 'resultado'),
        where('control_' + state.controlId + '_puesto_M', '>', 0),
        orderBy('control_' + state.controlId + '_puesto_M', 'asc'),
        limit(state.competicion.resultados_control_mostrar || RESULTADOS_MOSTRAR)
      );
    } else if (generoSelectedIndex === 3) {
      resultadosQuery = query(
        collection(db, 'resultado'),
        where('control_' + state.controlId + '_puesto_F', '>', 0),
        orderBy('control_' + state.controlId + '_puesto_F', 'asc'),
        limit(state.competicion.resultados_control_mostrar || RESULTADOS_MOSTRAR)
      );
    }

    this.unlisten.resultados = onSnapshot(resultadosQuery, (snapshot) => {
      let resultados = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      this.setState({ resultados: resultados });
    });
  }

  // UNSAFE_componentWillUpdate(nextProps, nextState) {
  //   const { db } = this.props;

  //   if (this.state.controles !== nextState.controles) {
  //     const old = this.state.controles;
  //     const now = nextState.controles;

  //     if (old.length === 0 && now.length) {
  //       let conResultados = now.filter(a => a.numero_llegados > 0);
  //       if (conResultados.length) {
  //         conResultados.sort((a, b) => a.distancia - b.distancia);
  //         this.setState({ controlId: parseInt(conResultados[conResultados.length - 1].id, 10) });
  //       } else {
  //         const primerControlNoMeta = now.find(c => c.tipo !== 'META');
  //         if (primerControlNoMeta) {
  //           this.setState({ controlId: parseInt(primerControlNoMeta.id, 10) });
  //         } else {
  //           this.setState({ controlId: parseInt(now[0].id, 10) });
  //         }
  //       }
  //     } else {
  //       let conResultados = now.filter(a => a.numero_llegados > 0);
  //       if (conResultados.length) {
  //         conResultados.sort((a, b) => a.distancia - b.distancia);
  //         let newControlId = null;
  //         for (let i = (conResultados.length - 1); i >= 0; i--) {
  //           let control = conResultados[i];
  //           let find = old.filter(a => a.id === control.id);
  //           if (find.length && parseInt(find[0].numero_llegados, 10) === 0) {
  //             newControlId = parseInt(find[0].id, 10);
  //             break;
  //           }
  //         }
  //         if (newControlId) {
  //           this.setState({
  //             controlId: newControlId,
  //             generoSelectedIndex: 1
  //           });
  //         }
  //       } else {
  //         if (now && now.length) {
  //           this.setState({ controlId: parseInt(now[0].id, 10) });
  //         }
  //       }
  //     }
  //   }

  //   if (this.state.controlId !== nextState.controlId) {
  //     this._seleccionaResultadosAdecuados(nextState);
  //   } else if (this.state.generoSelectedIndex !== nextState.generoSelectedIndex) {
  //     this._seleccionaResultadosAdecuados(nextState);
  //   }

  //   if (this.state.competicion !== nextState.competicion) {
  //     if (nextState.competicion && nextState.competicion.resultados_control_mostrar) {
  //       this._seleccionaResultadosAdecuados(nextState);
  //     }

  //     if (nextState.competicion) {
  //       // Validar que evento_id existe y convertirlo a string
  //       const eventoId = nextState.competicion.evento_id;

  //       if (eventoId) {
  //         const eventoRef = doc(db, 'evento', String(eventoId));
  //         this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
  //           let evento = snapshot.exists() ? snapshot.data() : null;
  //           if (evento) {
  //             evento.id = snapshot.id;
  //           }
  //           this.setState({ evento });
  //         });
  //       }
  //     }
  //   }
  // }
  componentDidUpdate(prevProps, prevState) {
    const { db } = this.props;

    if (prevState.controles !== this.state.controles) {
      const old = prevState.controles;
      const now = this.state.controles;

      if (old.length === 0 && now.length) {
        // Buscar último control con datos consultando resultados en Firestore
        const sortedDesc = [...now].filter(c => c.tipo !== 'SALIDA').sort((a, b) => b.distancia - a.distancia);
        const findLastControl = async () => {
          for (const control of sortedDesc) {
            const checkQ = query(
              collection(db, 'resultado'),
              where('control_' + control.id + '_puesto', '>', 0),
              limit(1)
            );
            const snap = await getDocs(checkQ);
            if (!snap.empty) {
              this.setState({ controlId: parseInt(control.id, 10) });
              return;
            }
          }
          const primero = now.find(c => c.tipo !== 'META') || now[0];
          this.setState({ controlId: parseInt(primero.id, 10) });
        };
        findLastControl();
      } else if (this.state.controlId) {
        // Firebase update: buscar si hay un control más avanzado con datos
        const controlActual = now.find(c => parseInt(c.id, 10) === parseInt(this.state.controlId, 10));
        if (controlActual) {
          const masAvanzados = now.filter(c => c.tipo !== 'SALIDA' && c.distancia > controlActual.distancia).sort((a, b) => b.distancia - a.distancia);
          const checkMasAvanzado = async () => {
            for (const control of masAvanzados) {
              const checkQ = query(
                collection(db, 'resultado'),
                where('control_' + control.id + '_puesto', '>', 0),
                limit(1)
              );
              const snap = await getDocs(checkQ);
              if (!snap.empty) {
                this.setState({ controlId: parseInt(control.id, 10) });
                return;
              }
            }
          };
          checkMasAvanzado();
        }
      }
    }

    if (prevState.controlId !== this.state.controlId) {
      this._seleccionaResultadosAdecuados();
    } else if (prevState.generoSelectedIndex !== this.state.generoSelectedIndex) {
      this._seleccionaResultadosAdecuados();
    }

    if (prevState.competicion !== this.state.competicion) {
      if (this.state.competicion && this.state.competicion.resultados_control_mostrar) {
        this._seleccionaResultadosAdecuados();
      }

      if (this.state.competicion) {
        const eventoId = this.state.competicion.evento_id;

        if (eventoId) {
          const eventoRef = doc(db, 'evento', String(eventoId));
          this.unlisten.evento = onSnapshot(eventoRef, (snapshot) => {
            let evento = snapshot.exists() ? snapshot.data() : null;
            if (evento) {
              evento.id = snapshot.id;
            }
            this.setState({ evento });
          });
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.unlisten.evento) {
      this.unlisten.evento();
    }
    if (this.unlisten.competicion) {
      this.unlisten.competicion();
    }
    if (this.unlisten.controles) {
      this.unlisten.controles();
    }
    if (this.unlisten.resultados) {
      this.unlisten.resultados();
    }
    if (this.unlisten.sectores) {
      this.unlisten.sectores();
    }
  }

  render() {
    const evento = this.state.evento;
    const competicion = this.state.competicion;

    let control = null;
    if (this.state.controles && this.state.controlId) {
      control = this.state.controles.filter(c => {
        return parseInt(c.id, 10) === parseInt(this.state.controlId, 10);
      });
      if (control && control.length) {
        control = control[0];
      }
    }

    if (!this.state.competicion || this.state.competicion.visible === undefined) {
      return <MsgNetLoading />;
    }

    return (
      <div>
        <TopHeaderMenu
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toogleSharePanel.bind(this)}
          competicion={this.state.competicion}
          evento={this.state.evento}
        />
        <CompeticionHeaderMenu
          competicion={this.state.competicion}
          selected={1}
          evento={this.state.evento}
        />
        <div className="pt-[6.75rem]">
          <ControlSelector
            controlList={this.state.controles}
            competicion={this.state.competicion}
            controlId={this.state.controlId}
            navigateToControl={(controlId) => { this.setState({ controlId }); }}
            showGeneroSelector={this.state.competicion.mostrar_filtro_sexo}
          />
          {this.state.resultados ? (
            this.state.controles.length > 0 && (
              <div>
                {this.state.competicion.mostrar_filtro_sexo && (
                  <GeneroSelector
                    selectedIndex={this.state.generoSelectedIndex}
                    toggleSexoTodos={() => { this.setState({ 'generoSelectedIndex': 1 }); }}
                    toogleSexoMasculino={() => { this.setState({ 'generoSelectedIndex': 2 }); }}
                    toogleSexoFemenino={() => { this.setState({ 'generoSelectedIndex': 3 }); }}
                  />
                )}
                <ResultadoList
                  resultados={this.state.resultados}
                  competicion={this.state.competicion}
                  controlId={this.state.controlId}
                  controles={this.state.controles}
                  sectores={this.state.sectores}
                  control={control}
                />
              </div>
            )
          ) : (
            <MsgNetLoading />
          )}
        </div>

        {this.state.showSharePanel && (
          <SharePanel
            close={this.toogleSharePanel.bind(this)}
            url={`/competicion/${competicion.id}`}
            title={`Líderes de carrera en vivo en la prueba ${competicion.nombre} en ${evento.nombre}`}
          />
        )}
      </div>
    );
  }
}

// Wrapper funcional para usar hooks de React Router v6
function CompeticionScreen() {
  const navigate = useNavigate();
  const params = useParams();
  const { db } = React.useContext(FirebaseContext);

  return <CompeticionScreenClass navigate={navigate} params={params} db={db} />;
}

export default CompeticionScreen;